import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'isPositiveRentalHistory',
    label: 'Positive rental history',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'caivrsNumber',
    label: 'CAIVRS Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'caivrsAuthorizationCode',
    label: 'CAIVRS Authorization Code',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const creditReportingForm = {
  name: FormNames.CREDIT_REPORTING,
  label: 'Credit Reporting',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
